import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from 'src/app/app.component';
import { AuthService } from 'src/app/utility/auth/auth.service';

import { BillingDetailComponent, BillingPriceComponent, ProductSearchComponent, SubscribeDetailComponent } from '@serengeti/serengeti-market';
import { ProducerListComponent } from '@serengeti/serengeti-market';
import { ProducerDetailComponent } from '@serengeti/serengeti-market';
import { ProductCreateComponent } from '@serengeti/serengeti-market';
import { ProductViewComponent } from '@serengeti/serengeti-market';
import { ProductListComponent } from '@serengeti/serengeti-market';
import { SubscribeListComponent } from '@serengeti/serengeti-market';
import { BillingListComponent } from '@serengeti/serengeti-market';
import { SettingConfigComponent } from '@serengeti/serengeti-market';
import { MarketProductCreateComponent } from 'src/app/market/product/create/create.component';
import { MarketProductDetailComponent } from 'src/app/market/product/detail/detail.component';
import { ShoppingListComponent } from '@serengeti/serengeti-market';


const routes: Routes = [
	{ path: 'main', component: AppComponent, canActivate: [AuthService], children: [
		{ path: 'market/producer/list', component: ProducerListComponent, outlet: 'content', data: { title: 'lib.market.producer.list.title', root: true } },
		{ path: 'market/producer/create', component: ProducerDetailComponent, outlet: 'content', data: { title: 'lib.market.producer.create.title', root: false } },
		{ path: 'market/producer/detail/:id/', component: ProducerDetailComponent, outlet: 'content', data: { title: 'lib.market.producer.detail.title', root: false } },
		{ path: 'market/product/search', component: ProductSearchComponent, outlet: 'content', data: { title: 'lib.market.product.search.title', root: true } },
		{ path: 'market/shopping/list', component: ShoppingListComponent, outlet: 'content', data: { title: 'lib.market.shopping.list.title', root: true } },
		{ path: 'market/product/list', component: ProductListComponent, outlet: 'content', data: { title: 'lib.market.product.list.title', root: true } },
		{ path: 'market/product/my', component: ProductListComponent, outlet: 'content', data: { title: 'lib.market.product.list.title', root: true } },
		{ path: 'market/product/create', component: MarketProductCreateComponent, outlet: 'content', data: { title: 'lib.market.product.detail.title', root: false } },
		{ path: 'market/product/detail/:id/', component: MarketProductDetailComponent, outlet: 'content', data: { title: 'lib.market.product.detail.title', root: false } },
		{ path: 'market/product/view/:id/', component: ProductViewComponent, outlet: 'content', data: { title: 'lib.market.product.view.title', root: false } },
		{ path: 'market/product/create', component: ProductCreateComponent, outlet: 'content', data: { title: 'lib.market.product.create.title', root: false } },
		{ path: 'market/subscribe/list', component: SubscribeListComponent, outlet: 'content', data: { title: 'lib.market.subscribe.list.title', root: true } },
		{ path: 'market/subscribe/detail/:id/', component: SubscribeDetailComponent, outlet: 'content', data: { title: 'lib.market.subscribe.detail.title', root: false } },
		{ path: 'market/billing/list', component: BillingListComponent, outlet: 'content', data: { title: 'lib.market.billing.list.title', root: true } },
		{ path: 'market/billing/detail/:id/', component: BillingDetailComponent, outlet: 'content', data: { title: 'lib.market.billing.detail.title', root: false } },
		{ path: 'market/billing/detail/:id/subscription/:subscriptionId/', component: BillingPriceComponent, outlet: 'content', data: { title: 'lib.market.billing.price.title', root: false } },
		{ path: 'market/setting/config', component: SettingConfigComponent, outlet: 'content', data: { title: 'lib.market.setting.config.title', root: true } },
	]},
];

@NgModule({
	declarations: [],
	imports: [
		RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true }),
		CommonModule
	]
})
export class AppRoutingMarketModule { }
